import { makeAuthorizedRequest } from './requests';

export function approveBilling(patientIds) {
  return makeAuthorizedRequest('PUT', '/patients/billingreports/approve', {
    patientIds,
  });
}
